import { configureStore } from "@reduxjs/toolkit";
import uiReducer from "./uiSlice";
import usersReducer from "./usersSlice";
import orderReducer from "@/features/order/slice";
import itemsSlice from "@/features/menu-item/slice";
import menusSlice from "@/features/menu/slice";
import AuthSlice from "@/features/auth/slice";
import templatesSlice from "@/features/admin/templates/slice";
import organizationsSlice from "@/features/organizations/slice";
import rolesSlice from "@/features/organizations/roles/slice";
import categoriesSlice from "@/features/categories/slice";
import quoteItemSlice from "./quoteItemSlice";
import { faqsApi } from "@/features/organizations/api/faqApi";
import { surveysApi } from "@/api/surveysApi";
import { contentSettingsApi } from "@/features/organizations/api/settingsApi";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { quotesApi } from "@/features/organizations/api/quoteApi";
import { accessApi } from "@/api/accessApi";
import { organizationsApi } from "@/features/organizations/api/organizationsApi";
import { orgCategoriesApi } from "@/features/organizations/api/OrgCategoryApi";
import { menusApi } from "@/features/organizations/api/menusApi";
import { contentApi } from "@/features/organizations/api/contentApi";
import { newtemplatesApi } from "@/api/templatesApi";
import { ordersApi } from "@/features/organizations/api/ordersApi";
import { websiteApi } from "@/features/organizations/api/websiteApi";
import { usersApi } from "@/api/usersApi";
import { branchApi } from "@/features/organizations/api/branchApi";
import { mediaApi } from "@/api/mediaApi";
import { orgCustomersApi } from "@/features/organizations/api/orgCustomersApi";
import { userOrgOrdersApi } from "@/api/userOrgOrdersApi";
import { tutorialsApi } from "@/api/tutorialsApi";
import { loyaltyApi } from "@/api/loyaltyApi";
import { authApi } from "@/api/authApi";
import { driversApi } from "@/api/driversApi";
import { aiCatalogApi } from "@/features/catalog/api/aiCatalogApi";
import { copilotApi } from "@/api/copilotApi";

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    users: usersReducer,
    order: orderReducer,
    items: itemsSlice,
    menus: menusSlice,
    auth: AuthSlice,
    templates: templatesSlice,
    organizations: organizationsSlice,
    roles: rolesSlice,
    quote: quoteItemSlice,
    categories: categoriesSlice,
    [faqsApi.reducerPath]: faqsApi.reducer,
    [contentSettingsApi.reducerPath]: contentSettingsApi.reducer,
    [surveysApi.reducerPath]: surveysApi.reducer,
    [quotesApi.reducerPath]: quotesApi.reducer,
    [accessApi.reducerPath]: accessApi.reducer,
    [organizationsApi.reducerPath]: organizationsApi.reducer,
    [orgCategoriesApi.reducerPath]: orgCategoriesApi.reducer,
    [menusApi.reducerPath]: menusApi.reducer,
    [contentApi.reducerPath]: contentApi.reducer,
    [branchApi.reducerPath]: branchApi.reducer,
    //replace templates
    [newtemplatesApi.reducerPath]: newtemplatesApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [websiteApi.reducerPath]: websiteApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [mediaApi.reducerPath]: mediaApi.reducer,
    [orgCustomersApi.reducerPath]: orgCustomersApi.reducer,
    [userOrgOrdersApi.reducerPath]: userOrgOrdersApi.reducer,
    [tutorialsApi.reducerPath]: tutorialsApi.reducer,
    [loyaltyApi.reducerPath]: loyaltyApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [driversApi.reducerPath]: driversApi.reducer,
    [aiCatalogApi.reducerPath]: aiCatalogApi.reducer,
    [copilotApi.reducerPath]: copilotApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // TODO: Replace this with a custom reducer that replace firestore timestamps
    })
      .concat(faqsApi.middleware)
      .concat(contentSettingsApi.middleware)
      .concat(surveysApi.middleware)
      .concat(quotesApi.middleware)
      .concat(accessApi.middleware)
      .concat(organizationsApi.middleware)
      .concat(orgCategoriesApi.middleware)
      .concat(menusApi.middleware)
      .concat(contentApi.middleware)
      .concat(newtemplatesApi.middleware)
      .concat(ordersApi.middleware)
      .concat(websiteApi.middleware)
      .concat(usersApi.middleware)
      .concat(branchApi.middleware)
      .concat(mediaApi.middleware)
      .concat(orgCustomersApi.middleware)
      .concat(userOrgOrdersApi.middleware)
      .concat(tutorialsApi.middleware)
      .concat(loyaltyApi.middleware)
      .concat(authApi.middleware)
      .concat(driversApi.middleware)
      .concat(aiCatalogApi.middleware)
      .concat(copilotApi.middleware)
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
